import script from "./TimelineTopOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimelineTopOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./TimelineTopOverlay.vue?vue&type=style&index=0&id=c810f130&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c810f130"]])

export default __exports__